import { Component, OnInit } from "@angular/core";
import { DefaultEditor } from "ng2-smart-table";

@Component({
  template: `
  <textarea *ngIf="cell.getColumn().isEditable" type="text" (change)="change($event)" nbInput fullWidth id="valorElements" name="valorElements" [(ngModel)]="currentValue"></textarea>
  `,
})
export class ElementsPropertyFieldComponent extends DefaultEditor implements OnInit{

  currentValue: any;

  ngOnInit(): void {

    if(this.cell.newValue.length > 0){
      this.currentValue = this.cell.newValue.map(e => {return e.replaceAll("|","\\|")}).join("|")
    }

    console.log(this.currentValue)
  }

  public change(event) {

    this.cell.newValue = this.currentValue.replaceAll("\\|","==TUBERIA==").split("|").map(e => { return e.replaceAll("==TUBERIA==","|")});

  }
}
